export default {
  adminDashboard: {
    booking: {
      download: 'Boekingen downloaden',
      downloadAppointmentBookingLogs: 'Afspraakboekingslogs downloaden',
      downloadAppointmentBookingLogsError:
        'Afspraakboekingslogs kunnen niet worden gedownload. Probeer het opnieuw.',
      downloadBookingLogsError:
        'Boekingsanalytics kunnen niet worden gedownload. Probeer het opnieuw.',
      downloadingAppointmentBookingLogs: 'Downloaden...',
      title: 'Boekingen',
    },
    chats: {
      chart: {
        answeredWithin4Hours: {
          caption:
            'per maand van in totaal {{total}} gesprekken in het jaar {{year}}',
          line: {
            answeredWithin4Hours: 'Beantwoord binnen 4 uur',
          },
          title: 'Chats beantwoord binnen de eerste 4 uur',
        },
        closedOpened: {
          caption: 'per maand van in totaal {{total}} gesprekken',
          key: {
            closed: 'Gesloten',
            open: 'Open',
          },
          title: 'Gesloten versus geopend',
        },
        conversations: {
          caption: 'dit jaar {{year}}',
          title: 'Gesprekken',
        },
        reasons: {
          caption: 'per maand van in totaal {{total}} gesprekken',
          title: 'Redenen voor binnenkomst',
        },
        responseTime: {
          caption:
            'per maand van in totaal {{total}} gesprekken in het jaar {{year}}',
          line: {
            firstReplyTime: 'Tijd eerste reactie',
            openedTime: 'Geopende tijd',
          },
          title: 'Reactietijd',
          yAxis: 'uren',
        },
      },
      monthly: 'Maandelijks',
      title: 'Chats',
    },
    tabs: {
      booking: 'Boekingen Dashboard',
      chats: 'Chats Dashboard',
      users: 'Gebruikers Dashboard',
    },
    users: {
      actions: {
        download: 'Gebruikers downloaden',
      },
      chart: {
        activePatients: {
          caption: '{{activePatients}} van de {{patients}} deze maand',
          title: 'Actieve patiënten',
        },
        newUsersByMonth: {
          caption: 'per maand in {{year}}',
          title: 'Nieuwe patiënten',
        },
        pie: {
          clinicians: 'Klinische specialisten',
          unverified: 'Niet geverifieerd',
          verifiedPatients: 'Geverifieerde patiënten',
        },
        totalUsers: {
          caption: 'van in totaal {{users}} gebruikers',
          title: 'Gebruikers',
        },
      },
      title: 'Gebruikers',
    },
  },
  auth: {
    logout: 'Uitloggen',
    noPermissions:
      'Je hebt geen toestemming om toegang te krijgen tot deze pagina.',
  },
  brochures: {
    actions: {
      cancel: 'Annuleren',
      confirm: 'Bevestigen',
    },
    addTreatment: 'Behandeling toevoegen',
    allCategories: 'Alle categorieën',
    confirm: {
      cancel: 'Annuleren',
      confirm: 'Bevestigen',
      header: 'Bevestig behandeling',
      text: 'Weet u zeker dat u de behandeling wilt bevestigen?',
    },
    failedToEdit: 'Bewerken van folder mislukt',
    filterPlaceholder: 'Filter op categorie',
    noBrochures:
      'Deze patiënt heeft nog geen folders. Voeg een behandeling toe om te beginnen.',
    preview: {
      email: 'E-mailen',
      error: {
        description: 'Probeer het later opnieuw',
        title: 'Er is iets misgegaan',
      },
      language: 'In welke taal wilt u de folder tonen en verzenden?',
      languages: {
        'en-GB': 'Engels',
        'nl-NL': 'Nederlands',
      },
      print: 'Afdrukken',
      sendConfirm: {
        cancel: 'Annuleren',
        confirm: 'Verzenden',
        error: 'Er is iets misgegaan. Probeer het later opnieuw.',
        header: 'Folder naar patiënt verzenden',
        success: 'De folder is succesvol verzonden',
        text: 'Weet u zeker dat u de folder wilt versturen naar het e-mailadres van de patiënt ({{email}})?',
      },
    },
    removeBrochures: 'Behandeling verwijderen',
    searchPlaceholder: 'Zoek in alle behandelingen',
    sidebarTitle: 'Behandelingen',
    status: {
      emailed: 'Verzonden op {{date}}',
      printed: 'Afgedrukt op {{date}}',
    },
    title: 'Folders',
  },
  chat: {
    actions: {
      approveAndSend: 'Goedkeuren en verzenden',
      cancel: 'Annuleren',
      close: 'Chat sluiten',
      edit: 'Bewerken',
      queueLabel: 'Wachtrij',
      reasonLabel: 'Reden',
      returnToQueue: 'Terug naar wachtrij',
      revert: 'Wijzigingen ongedaan maken',
      save: 'Opslaan',
      start: 'Chat beantwoorden',
    },
    assign: {
      button: 'toewijzen aan',
      confirmModal: {
        button: 'toewijzen',
        cancel: 'annuleren',
        confirm: 'toewijzen',
        header: 'Chat toewijzen?',
        text: 'Als je dit chatgesprek toewijst, dan wordt de interne chat gesloten. De andere deelnemers zien de interne chat dan niet meer. Je kunt eerdere interne chatgesprekken terugvinden bij de patiënteninformatie.',
      },
      modal: {
        button: 'toewijzen',
        header: 'Toewijzen aan',
        inputPlaceholder: 'Zoek in alle gebruikers',
      },
    },
    close: {
      cancel: 'annuleren',
      confirm: 'Chat sluiten',
      confirmAndSaveReport: 'Chat sluiten en rapport opslaan',
      conversation: {
        header: 'Chat sluiten?',
        text: 'Dit kan niet ongedaan gemaakt worden. Gesloten chatgesprekken blijven 1 week bewaard. Je vindt ze terug bij de patiënteninformatie.',
      },
      includeImages: 'Van patiënt ontvangen afbeeldingen bijvoegen',
      internal: {
        header: 'Interne chat sluiten?',
        text: 'Het chatgesprek met de patiënt blijft actief als je de interne chat sluit. Gesloten chatgesprekken blijven 1 week bewaard. Je vindt ze terug bij de patiënteninformatie.',
      },
      patientNotes: 'Notities voor in het rapport',
      saveReport: 'Rapport van deze chat opslaan',
      triageNote: 'Triage-antwoorden worden automatisch aan rapport toegevoegd',
    },
    events: {
      conversationAssignedTo: '{{user}} is toegevoegd aan de chat',
      conversationClosedBy: 'Chat is gesloten door {{user}}',
      conversationMovedToQueue: 'Chat verplaatst naar {{queue}}',
      conversationReasonForEntryChanged:
        'Reden gewijzigd van {{old}} in {{new}} door {{user}}',
      conversationUnassignedBy: '{{user}} heeft de chat verlaten',
      conversationUnassignedBySystem:
        'Chat is automatisch teruggestuurd naar de wachtrij door het systeem',
    },
    hiddenImage: 'Afbeeldingen zijn niet beschikbaar in gesloten chats',
    inbox: 'Inbox',
    inputPlaceholder: 'Schrijf een bericht',
    noActiveConversations: 'Selecteer een patiënt om te beginnen met chatten',
    notifications: {
      conversationCreated: 'Nieuw gesprek van {{user}}',
      internalConversationCreated: 'Nieuwe interne chat van {{user}}',
      messageAdded: 'Nieuw bericht van {{user}}',
    },
    ongoingConversations: 'actieve chats',
    queue: 'wachtrij',
    reasons: {
      Urgent: 'Dringend',
    },
    returnToQueue: {
      cancel: 'annuleren',
      confirm: 'verplaatsen naar wachtrij',
      header: 'Chat verplaatsen naar wachtrij?',
      text: 'Als je dit chatgesprek naar de wachtrij verplaatst, wordt de interne chat gesloten. De andere deelnemers zien de interne chat dan niet meer. Je kunt eerdere interne chatgesprekken terugvinden bij de patiënteninformatie.',
    },
    suggestion: {
      feedback: {
        defects: 'Gebreken',
        editedMessage: 'Bewerkte bericht:',
        header: 'Bewerkte reactie beoordelen',
        originalMessage: 'Oorspronkelijk bericht:',
        send: 'Bericht verzenden',
      },
      messageLabel: 'Bekijk deze gegenereerde reactie',
    },
    triage: {
      accordionTitle: 'Patient triage questions',
    },
    userTyping: '{{name}} is aan het schrijven',
  },
  common: {
    searchInputClear: 'Wissen',
  },
  connectionBanner: {
    dismiss: 'Sluiten',
    message: 'Chatverbinding niet beschikbaar.',
    retry: 'Opnieuw proberen',
  },
  consultations: {
    action: {
      closeConsultation: 'Close consultation',
      readyForReview: 'Klaar voor behandelaar',
    },
    chat: {
      finished: 'De patiënt kan niet meer reageren op dit e-consult',
    },
    closeConsultation: {
      action: {
        cancel: 'Annuleren',
        close: 'E-consult sluiten en transcript opslaan',
      },
      description:
        'Na het sluiten van dit e-consult worden een transcript van het e-consult en de verzonden afbeeldingen als PDF opgeslagen in EMMA. U kunt hieronder optioneel een aanvullende notitie toevoegen.',
      label: 'Notitie toevoegen (optioneel)',
      title: 'E-consult sluiten?',
    },
    errorClosing:
      'We couldn’t finalize the consultation due to an error. Please try again or refresh the page.',
    noConsultationsSelected: 'Selecteer een consult om te starten',
    queue: {
      finished: 'Afgerond',
      finishedTooltip:
        'Het consult is afgerond, maar de patiënt heeft het nog niet gelezen',
      patient: 'Patiënt',
      readyForReview: 'Klaar voor behandelaar',
      readyForReviewTooltip:
        'Het consult is klaar voor beoordeling door de behandelaar',
      title: 'E-consults',
    },
    submitMessage: {
      action: {
        cancel: 'Annuleren',
        send: 'Antwoord versturen',
        sendAndClose: 'Versturen en sluiten',
      },
      description:
        'Sta een reactie van de patiënt toe als u een vervolgvraag heeft gesteld waarvoor aanvullende toelichting nodig is.',
      options: {
        allowReply: 'Sta patiënt toe te reageren (e-consult blijft open)',
        doNotAllowReply:
          'Sta patiënt niet toe te reageren (e-consult wordt gesloten)',
      },
      title: 'Patiënt laten reageren?',
    },
  },
  dcAssistant: {
    chatAssistant: 'Chat Assistent',
    inputPlaceholder: 'Stel een vraag over deze patiënt aan de AI-assistent',
    patientKnowledgeBase: 'Patiënt Kennisbank',
  },
  econsultations: {
    undo_ready: 'Ongedaan maken',
    undo_ready_modal_confirm: 'Ongedaan maken',
    undo_ready_modal_description: 'De e-consultatie wordt weer actief.',
    undo_ready_modal_title: 'Klaar voor behandelaar ongedaan maken?',
  },
  generic: {
    noEmail: 'GEEN E-MAIL BESCHIKBAAR',
  },
  handTherapy: {
    actions: {
      add: 'Toevoegen',
      cancel: 'Annuleren',
      confirm: 'Programma toewijzen',
      remove: 'Verwijderen',
    },
    changeProgram: 'Wijzig programma',
    exercises: {
      button: 'Oefening toevoegen',
      frequency: 'Aantal keren',
      frequencyOptions: {
        day: 'dag',
        hour: 'uur',
      },
      instructions: 'Instructies',
      locations: {
        clinic: 'In de kliniek',
        home: 'Thuis',
      },
      reps: 'Reps',
      rest: 'Rust',
      sets: 'Sets',
      title: 'Oefeningen',
      videoPreview: 'Videovoorbeeld',
    },
    notFound: {
      backTo: 'Zoek patiënten',
      title:
        'Sorry, we kunnen het programma {{programId}} niet terugvinden. Zoek de patiënt op om verder te gaan.',
    },
    sidebar: {
      allAreasLabel: 'Alle categoriën',
      allLocations: 'Alle locaties',
      area: {
        dexterity: 'Oefenruimte: behendigheid',
        elbow: 'Elleboog',
        finger: 'Vinger',
        general: 'ADL oefeningen',
        mobility: 'Oefenruimte: beweeglijkheid',
        nerve: 'Zenuw',
        shoulder: 'Schouder',
        strength: 'Oefenruimte: kracht',
        thumb: 'Duim',
        wrist: 'Pols',
      },
      areaOfConcernPlaceholder: 'Categorie',
      locations: {
        clinic: 'In de kliniek',
        home: 'Thuis',
      },
      locationsPlaceholder: 'Locatie',
      searchExercisesPlaceholder: 'Zoek in alle oefeningen',
      title: {
        exercises: 'Oefeningen',
        splints: 'Spalk',
      },
    },
    splints: {
      button: 'Spalk toevoegen',
      frequencyOptions: {
        day: 'dag',
        'day-night': 'dag en nacht',
        night: "'s nachts",
      },
      instructions: 'Instructies',
      title: 'Spalk',
      wearDuring: 'Dragen gedurende',
    },
  },
  internalChat: {
    action: 'Start interne chat',
    placeholder: 'Schrijf een bericht',
    searchbarPlaceholder: 'Zoek in alle gebruikers',
    title: 'Interne chat:',
  },
  login: {
    confirm: 'Log in',
    description: 'Log in met eCumulus om door te gaan',
  },
  navbar: {
    activations: 'Activeringen',
    adminPanel: 'admin',
    chat: 'Chat',
    chatAssistant: 'Chatassistent',
    dashboard: 'Dashboard',
    eConsultations: 'E-Consult',
    logout: 'Uitloggen',
    patients: 'Patiënten',
    userManagement: 'Gebruikersbeheer',
  },
  patientScreen: {
    navigation: {
      brochures: {
        description: 'Bekijk en bewerk het behandelplan van je cliënt',
        title: 'Folders',
      },
      eConsultations: {
        description: 'Bekijk en beheer e-consultaties voor deze cliënt',
        title: 'E-consult',
      },
      exercises: {
        description:
          'Maak een oefenprogramma voor je cliënt. Met instructies op maat en spalken.',
        title: 'Oefeningen',
      },
      knowledgeBase: {
        description:
          'Stel vragen over zorgpaden, afspraken en behandelplannen van de patiënt',
        title: 'Patiënt Kennisbank',
      },
      openButton: 'openen',
      pdfLookup: {
        description: 'Bekijk, mail en print ICL’s voor deze cliënt',
        title: 'Cliëntinstructies',
      },
    },
    notFound: {
      backTo: 'Zoek patiënten',
      title: 'Patiënt niet gevonden',
    },
  },
  patientSearch: {
    actions: {
      clear: 'Wissen',
    },
    instructions: 'Typ Enter om te patiënten te zoeken',
    noResults: 'Geen patiënten gevonden',
    searchbarPlaceholder: 'Zoek patiënt op naam of ID',
    shortQueryWarning: 'Typ minimaal 3 tekens om te zoeken',
    title: 'Hallo, {{name}}',
  },
  patientSidebar: {
    carePath: {
      appointmentActions: {
        appointmentList: 'Afsprakenlijst',
        cancelAction: 'Afspraak annuleren',
        cancelSuccess: 'Afspraak succesvol geannuleerd.',
        cancelTitle: 'Afspraak annuleren',
        changeAction: 'Afspraaktijd wijzigen',
        changeSuccess: 'Afspraaktijd succesvol gewijzigd.',
        changeTitle: 'Afspraaktijd wijzigen',
        confirmCancel: 'Afspraak annuleren',
        confirmCancelText:
          'Je staat op het punt deze afspraak voor de patiënt te annuleren. Bevestig dat de patiënt hiermee akkoord is.',
        confirmCancelTitle: 'Annulering bevestigen',
        confirmChange: 'Afspraaktijd wijzigen',
        confirmChangeText:
          'Je staat op het punt deze afspraak voor de patiënt te wijzigen. Bevestig dat de patiënt akkoord is met het nieuwe tijdstip.',
        confirmChangeTitle: 'Wijziging bevestigen',
        detailsTitle: 'Afspraakgegevens',
        mutationStatusUnknown:
          'Het verzoek is ontvangen, maar het resultaat kon niet worden bevestigd. Dien het niet opnieuw in; vernieuw eerst de afsprakenlijst.',
        newSlot: 'Nieuw afspraaktijdstip',
        noSlots: 'Er zijn momenteel geen alternatieve tijdstippen beschikbaar.',
        otherReasonPlaceholder: 'Voeg een korte toelichting toe',
        reasonTitle: 'Reden',
        reportingTime: 'Melden om: {{time}}',
        reviewCancel: 'Annulering controleren',
        reviewChange: 'Wijziging controleren',
        selectSlot: 'Kies een nieuw tijdstip',
        slotsUnavailable:
          'Alternatieve tijdstippen konden niet worden geladen. Probeer het opnieuw.',
        submitting: 'Opslaan...',
        warningTitle: 'Waarschuwing',
      },
      closedCarePaths: 'Afgeronde behandelingen',
      currentCarePaths: 'Lopende behandelingen',
      joinCall: 'Deelnemen',
      loadingAppointments: 'Laden...',
      nMore: '{{num}} meer',
      noActiveCarePaths: 'Geen lopende behandelingen',
      noClosedCarePaths: 'geen afgeronde behandelingen',
      noContent: 'Er zijn geen afspraken om weer te geven.',
      noMoreAppointments: 'Geen afspraken meer',
      numActiveCarePathsPlural: '{{num}} lopende behandelingen',
      numActiveCarePathsSingular: '1 lopende behandeling',
      numClosedCarePathsPlural: '{{num}} afgeronde behandelingen',
      numClosedCarePathsSingular: '1 afgeronde behandeling',
      past: 'Verleden',
      planned: 'Gepland',
      today: 'Vandaag',
    },
    chats: {
      backToList: 'Terug naar overzicht chats',
      internal: {
        title: 'Interne chat',
      },
      noContent: 'Er zijn geen chats om weer te geven.',
      noEvents: 'Er zijn geen chats om weer te geven.',
      ongoing: 'Actieve chats',
      past: 'Eerdere chats',
    },
    expandProfile: 'Patiëntprofiel  uitvouwen',
    openPatientHub: 'Patiëntenhub openen',
    pdfs: {
      created: 'Behandeling: {{- date}}',
      error: {
        description: 'Probeer het later opnieuw',
        title: 'Er is iets misgegaan',
      },
      languages: {
        'en-GB': 'Engels',
        'nl-NL': 'Nederlands',
      },
      noCarePlanSelected: {
        description: 'Selecteer een cliëntinstructie uit de lijst rechtsonder',
        title: 'Er zijn momenteel geen items om weer te geven',
      },
      noCarePlans: 'Geen zorgplannen gevonden',
      onGoingCarePlans: 'Cliëntinstructies lopende behandelingen',
      pastCarePlans: 'Cliëntinstructies afgeronde behandelingen',
      sendPDF: {
        cancel: 'Annuleren',
        confirm: 'Verzenden',
        error: 'Er is iets misgegaan. Probeer het later opnieuw.',
        header: 'Cliëntinstructie naar patiënt verzenden',
        language: 'In welke taal wilt u de PDF verzenden?',
        success: 'De PDF is succesvol verzonden',
        text: 'Weet u zeker dat u de PDF naar het e-mailadres van de patiënt wilt sturen {{email}}?',
      },
    },
    questionnaires: {
      completed: 'Afgerond',
      expired: 'Verlopen',
      noContent: 'Er zijn geen vragenlijsten om weer te geven.',
      patient: 'Vragenlijsten patiënt',
      therapist: 'Vragenlijsten therapeut',
      todo: 'Nog invullen',
    },
    tabs: {
      carePath: 'Afspraken',
      chats: 'Chats',
      questionnaires: 'Vragenlijsten',
    },
  },
  patientSidebarScreen: {
    backToCandidates: 'Terug naar gevonden patiënten',
    error: 'Fout bij het ophalen van de patiëntinformatie',
    multipleMatches:
      'Er zijn meerdere patiënten gevonden. Selecteer de juiste patiënt.',
    notFound: 'Geen patiënt gevonden voor dit gesprek.',
    selectPatient: 'Selecteren',
  },
  preCall: {
    description:
      'Scan de QR-code met een mobiel apparaat om deel te nemen aan het videogesprek. Of typ de link hieronder in de browser van je mobiele apparaat en vul de code in.',
  },
  programSelection: {
    actions: {
      cancel: 'Annuleren',
      confirm: 'Kies programma',
    },
    exercise: 'Oefening',
    noPrograms: `Geen programma's gevonden`,
    searchPlaceholder: `Zoek programma's`,
    splint: 'Spalk',
    titles: {
      change: 'Programma wijzigen',
      select: 'Kies programma',
    },
  },
  routeError: {
    backToPatients: 'Terug naar patiënten',
    description: 'Probeer het opnieuw of ga terug naar de patiëntenlijst.',
    title: 'Er is iets misgegaan',
  },
  unknown: 'onbekend',
  userManagement: {
    actions: {
      cancel: 'Annuleren',
      delete: 'Verwijderen',
      save: 'Opslaan',
    },
    activations: {
      actions: {
        download: 'Download activeringen',
        findMatches: 'Zoek Matches',
      },
      columns: {
        actions: 'Acties',
        activated: 'Geactiveerd',
        activatedAt: 'Geactiveerd op',
        bsn: '...BSN',
        createdAt: 'Aangemaakt op',
        dateOfBirth: 'Geboortedatum',
        dateOfRequest: 'Datum van aanvraag',
        email: 'E-mail',
        firebaseId: 'Firebase ID',
        name: 'Naam',
        phoneNumber: 'Telefoonnummer',
        status: 'Status',
      },
      delete: {
        action: 'Verwijderen',
        cancel: 'Annuleren',
        clearSelection: 'Selectie wissen',
        close: 'Sluiten',
        codes: {
          activated: 'Al geactiveerd',
          'db-error': 'Gegevens konden niet worden verwijderd',
          'firebase-error': 'Account kon niet worden verwijderd',
          'linked-patient': 'Gekoppeld aan een patiëntdossier',
          'not-found': 'Niet gevonden (mogelijk al verwijderd)',
          'own-account': 'Eigen account',
          'privileged-account': 'Medewerkersaccount',
        },
        confirm: 'Definitief verwijderen',
        error: 'Verwijderen is mislukt. Probeer het opnieuw.',
        message:
          '{{count}} geselecteerde account(s) en de bijbehorende aanvraaggegevens worden definitief verwijderd. De persoon wordt uitgelogd en moet zich opnieuw registreren om de app te gebruiken.',
        pending: 'Verwijderen...',
        reasonLabel: 'Reden',
        reasonPlaceholder: 'Kies een reden',
        reasons: {
          duplicate: 'Dubbele aanvraag',
          no_match: 'Geen match gevonden',
          other: 'Overig',
          subject_request: 'Op verzoek van de persoon zelf',
          test_account: 'Testaccount',
        },
        selectPage: 'Alles op deze pagina selecteren',
        selectRow: 'Rij selecteren',
        selected: '{{count}} geselecteerd',
        summary:
          '{{deleted}} verwijderd, {{skipped}} overgeslagen, {{failed}} mislukt',
        title: 'Accounts definitief verwijderen',
        warning: 'Deze actie kan niet ongedaan worden gemaakt.',
      },
      display: 'Weergave: {{amount}} van {{total}}',
      displayFocused: 'Gefocuste weergave: {{email}}',
      errorLoadingMatches: 'Fout bij het laden van matches',
      filtering: 'Filteren...',
      loading: 'Laden...',
      loadingMatches: 'Matches laden',
      manualEntry: {
        clearSelection: 'Selectie wissen',
        errors: {
          invalidFormat:
            'Ongeldig formaat. Gebruik <patiënt-id>@<org-id> (bijv. 1234567@73) of plak vanuit Patiënt IDs veld',
          lookupFailed: 'Patiënt opzoeken mislukt',
          required: 'Patiëntnummer is verplicht',
        },
        formatHint:
          'Formaat: <patiënt-id>@<org-id> (bijv. 1234567@73). U kunt ook het volledige [id1@org,id2@org] formaat plakken.',
        inputLabel: 'Patiëntnummer',
        inputPlaceholder: 'bijv. 1234567@73 of [1234567@73,7654321@88]',
        lookupButton: 'Opzoeken',
        lookupButtonLoading: 'Zoeken...',
        patientDetails: {
          dateOfBirth: 'Geboortedatum',
          email: 'E-mail',
          phone: 'Telefoon',
          pulseIds: 'Patiënt IDs',
        },
        searching: 'Patiënt zoeken...',
        selectPatient: 'Selecteer deze patiënt',
        toggleLabel: 'Patiënt niet gevonden? Voer patiëntnummer handmatig in',
      },
      matches: {
        actions: {
          activate: 'Activeren',
        },
        badges: {
          dobMatch: 'Geb.datum ✓',
          emailMismatch: 'E-mail ✗',
          nameMatch: 'Naam ✓',
        },
        columns: {
          actions: 'Acties',
          birthDate: 'Geboortedatum',
          email: 'E-mail',
          equipeId: 'Equipe ID',
          gender: 'Geslacht',
          matchType: 'Match',
          name: 'Naam',
          patientId: 'Patiënt ID',
          phoneNumber: 'Telefoon',
          status: 'Status',
        },
        found: '{{count}} patiënt match(es) gevonden',
        loading: 'Zoeken naar matches...',
        matchTypes: {
          both: 'E-mail + Telefoon',
          email: 'Alleen e-mail',
          'name-dob': 'Naam/Geboortedatum',
          phone: 'Alleen telefoon',
        },
        multipleWarning:
          '⚠️ Meerdere matches gevonden - verifieer voor activatie',
        noMatches: 'Geen patiënt matches gevonden in Pulse systeem',
        status: {
          active: 'Actief',
          inactive: 'Inactief',
        },
        title: 'Patiënt Matches',
      },
      modal: {
        activate: 'Geselecteerde patiënt activeren',
        activating: 'Activeren...',
        close: 'Sluiten',
        description: 'Beschrijving en/of instructies hier',
        emailMismatchConfirmation: {
          cancel: 'Annuleren',
          confirm: 'Ja, toch koppelen',
          message:
            'Het e-mailadres van het account komt niet overeen met het e-mailadres van het geselecteerde patiëntdossier. Door te koppelen krijgt dit account toegang tot de medische gegevens van die patiënt.',
          title: 'E-mailadres komt niet overeen',
          warning:
            'Ga alleen verder als u heeft geverifieerd dat dit de juiste patiënt is.',
        },
        reject: 'Aanvraag afwijzen',
        rejectConfirmation: {
          cancel: 'Annuleren',
          confirm: 'Ja, aanvraag afwijzen',
          message:
            'Weet u zeker dat u deze aanvraag wilt afwijzen? De gebruiker ontvangt een e-mail en wordt uitgelogd uit de app.',
          title: 'Afwijzing bevestigen',
          warning: 'Deze actie kan niet ongedaan worden gemaakt.',
        },
        rejectReasonPlaceholder:
          'Voer de reden voor afwijzing in (bijv. "Wij kunnen uw aanvraag niet goedkeuren omdat uw laatste afspraak te lang geleden was. Neem contact op met ons informatiecentrum.")',
        rejectTitle: 'Deze aanvraag afwijzen',
        rejecting: 'Afwijzen...',
        tableTitle: 'Mogelijke patiënt matches',
        title: 'Patiënt matches',
      },
      noMatchesFound: 'Geen matches gevonden',
      reviewReasons: {
        activation_failed: 'Activatie mislukt',
        dob_conflict: 'Geboortedatum wijkt af',
        email_conflict: 'E-mail wijkt af',
        invalid_phone: 'Ongeldig telefoonnummer',
        missing_pulse_ids: 'Geen patiëntnummer',
        multiple_matches: 'Meerdere matches',
        no_match: 'Geen match',
        notEvaluated: 'Nieuw',
        unconfirmed_email: 'E-mail onbevestigd',
        unsafe_existing_external_id: 'Al gekoppeld',
      },
      title: 'Activeringen',
    },
    export: {
      bytesDownloaded: '{{bytes}} gedownload',
      cancel: 'Annuleren',
      close: 'Sluiten',
      status: {
        complete: 'Export voltooid!',
        downloading: 'Export downloaden...',
        downloadingWithProgress:
          'Downloaden... {{current}} van {{total}} records',
        error: 'Export mislukt',
        preparing: 'Export voorbereiden...',
      },
      title: 'Gebruikers exporteren',
    },
    featureFlags: {
      actions: {
        add: 'Nieuwe feature flag',
      },
      columns: {
        actions: 'Acties',
        description: 'Beschrijving',
        enabled: 'Ingeschakeld',
        key: 'Sleutel',
        title: 'Titel',
        value: 'Waarde',
      },
      createModal: {
        error:
          'Er was een probleem bij het aanmaken van de nieuwe feature flag, controleer of de sleutel uniek is',
        title: 'Nieuwe feature flag aanmaken',
      },
      deleteModal: {
        caption:
          'Weet u zeker dat u de feature flag {{title}} wilt verwijderen?',
        error: 'Er was een probleem bij het verwijderen van de feature flag',
        title: 'Feature flag verwijderen',
      },
      editModal: {
        error: 'Er was een probleem bij het bijwerken van de feature flag',
        title: 'Feature flag bewerken',
      },
      expandFeatureFlag: {
        actions: {
          clearSelection: 'Reset',
          deleteSelected: 'Verwijderen',
          downloadCsv: 'Waarden downloaden',
          selectAll: 'Alles selecteren',
          uploadCsv: 'CSV uploaden',
        },
        addNewValuePlaceholder: 'Nieuwe waarde toevoegen',
        breadcrumb: 'Terug naar alle functies',
        error: {
          errorUpdatingFeatureFlag:
            'Fout bij het bijwerken van de functievlag. Probeer het opnieuw.',
          noFeatureFlagFound:
            'Functievlag met sleutel {{key}} niet gevonden. Ga terug.',
          noItemsFound: 'Geen items gevonden met {{query}}',
        },
        searchbarPlaceholder: 'Zoeken...',
        uploadFileModal: {
          actions: {
            save: 'Opslaan',
          },
          error: {
            fileNotCSV: 'Ongeldig bestandstype. Geef een CSV-bestand op',
            noFileProvided: 'Geen bestand opgegeven',
          },
          title: 'CSV-bestand uploaden',
        },
        values: 'Waarden',
      },
      title: 'Feature flags',
    },
    permissions: {
      actions: {
        add: 'Nieuwe machtiging',
      },
      columns: {
        actions: 'Acties',
        description: 'Beschrijving',
        name: 'Naam',
      },
      createModal: {
        caption:
          'Machtigingen moeten ook aan de codebase worden toegevoegd om in de applicatie te worden gebruikt',
        error:
          'Er was een probleem bij het aanmaken van de nieuwe machtiging, controleer of de naam uniek is',
        title: 'Nieuwe machtiging aanmaken',
      },
      deleteModal: {
        caption: 'Weet u zeker dat u de machtiging {{name}} wilt verwijderen?',
        error:
          'Er was een probleem bij het verwijderen van de machtiging, zorg ervoor dat deze niet in gebruik is',
        title: 'Machtiging verwijderen',
      },
      editModal: {
        error:
          'Er was een probleem bij het bijwerken van de machtiging, controleer of de naam uniek is',
        title: 'Machtiging bewerken',
      },
      title: 'Machtigingen',
    },
    queues: {
      actions: {
        add: 'Nieuwe wachtrij',
      },
      columns: {
        actions: 'Acties',
        description: 'Beschrijving',
        title: 'Titel',
        userGroups: 'Gebruikersgroepen',
      },
      createModal: {
        error:
          'Er was een probleem bij het aanmaken van de nieuwe wachtrij, controleer of de naam uniek is en alle velden zijn ingevuld',
        title: 'Nieuwe wachtrij aanmaken',
      },
      deleteModal: {
        caption: 'Weet u zeker dat u de wachtrij {{title}} wilt verwijderen?',
        error:
          'Er was een probleem bij het verwijderen van de wachtrij, controleer of er geen gebruikersgroepen aan gekoppeld zijn',
        title: 'Wachtrij verwijderen',
      },
      editModal: {
        error:
          'Er was een probleem bij het bijwerken van de wachtrij, controleer of de naam uniek is en alle velden zijn ingevuld',
        title: 'Wachtrij bewerken',
      },
      title: 'Wachtrijen',
    },
    reasons: {
      actions: {
        add: 'Nieuwe reden',
        editOrder: 'Volgorde bewerken',
        saveOrder: 'Volgorde opslaan',
      },
      columns: {
        actions: 'Acties',
        contentfulId: 'Contentful ID',
        organizations: 'Organisaties',
        priority: 'Prioriteit',
        queue: 'Wachtrij',
        title: 'Titel',
        urgent: 'Urgent',
      },
      createModal: {
        error:
          'Er was een probleem bij het aanmaken van de nieuwe reden, controleer of de titel uniek is en alle velden zijn ingevuld',
        title: 'Nieuwe reden aanmaken',
      },
      deleteModal: {
        caption: 'Weet u zeker dat u de reden {{title}} wilt verwijderen?',
        error:
          'Er was een probleem bij het verwijderen van de reden, zorg ervoor dat deze niet in gebruik is in gesprekken',
        title: 'Reden verwijderen',
      },
      editModal: {
        error:
          'Er was een probleem bij het bijwerken van de reden, controleer of de titel uniek is en alle velden zijn ingevuld',
        title: 'Reden bewerken',
      },
      title: 'Redenen',
    },
    roles: {
      actions: {
        add: 'Nieuwe rol',
      },
      columns: {
        actions: 'Acties',
        azureGroups: 'Azure Groups',
        description: 'Beschrijving',
        name: 'Naam',
        permissions: 'Machtigingen',
        value: 'Waarde',
      },
      createModal: {
        error:
          'Er was een probleem bij het aanmaken van de nieuwe rol, controleer of de naam uniek is en machtigingen aanwezig zijn',
        title: 'Nieuwe rol aanmaken',
      },
      deleteModal: {
        caption: 'Weet u zeker dat u de rol {{name}} wilt verwijderen?',
        error:
          'Er was een probleem bij het verwijderen van de rol, zorg ervoor dat deze niet in gebruik is',
        title: 'Rol verwijderen',
      },
      editModal: {
        error:
          'Er was een probleem bij het bijwerken van de rol, controleer of de naam uniek is',
        title: 'Rol bewerken',
      },
      title: 'Rollen',
    },
    tabs: {
      activations: 'Activeringen',
      featureFlags: 'Feature flags',
      reasons: 'Redenen en Wachtrijen',
      roles: 'Rollen en Machtigingen',
      users: 'Gebruikers',
    },
    users: {
      actions: {
        add: 'Nieuwe gebruiker',
        download: 'Gebruikers downloaden',
        downloading: 'Downloaden...',
      },
      columns: {
        actions: 'Acties',
        email: 'E-mail',
        lastSignIn: 'Laatste aanmelding',
        name: 'Naam',
        patientId: 'Patiënt ID',
        roles: 'Rollen',
        verified: 'Geverifieerd',
      },
      createModal: {
        error:
          'Er was een probleem bij het aanmaken van de nieuwe gebruiker, controleer of het e-mailadres uniek is en de naam aanwezig is',
        title: 'Nieuwe gebruiker aanmaken',
      },
      deleteModal: {
        caption: 'Weet u zeker dat u gebruiker {{email}} wilt verwijderen?',
        error: 'Er was een probleem bij het verwijderen van de gebruiker',
        title: 'Gebruiker verwijderen',
      },
      display: 'Weergave: {{amount}} van {{total}}',
      editModal: {
        emailMismatchConfirmation: {
          cancel: 'Annuleren',
          confirm: 'Ja, toch opslaan',
          message:
            'Dit patiënt ID hoort bij een patiëntdossier met een ander e-mailadres. Door op te slaan koppelt u dit account aan die patiënt.',
          title: 'E-mailadres komt niet overeen',
        },
        error:
          'Er was een probleem bij het bijwerken van de gebruiker, controleer of het e-mailadres uniek is',
        title: 'Gebruiker bewerken',
      },
      filters: {
        email: 'E-mail',
        emailPlaceholder: 'Filter op e-mail...',
        name: 'Naam',
        namePlaceholder: 'Filter op naam...',
        pulseIds: 'Pulse IDs',
        pulseIdsPlaceholder: 'Filter op pulse IDs...',
        search: 'Globaal Zoeken',
        searchPlaceholder: 'Zoek gebruikers...',
        status: 'Status',
        statusActive: 'Actief',
        statusAll: 'Alle Statussen',
        statusArchived: 'Gearchiveerd',
        statusPlaceholder: 'Selecteer status...',
        type: 'Gebruikerstype',
        typeAll: 'Alle Types',
        typeClinician: 'Klinisch specialist',
        typePatient: 'Patiënt',
        typePlaceholder: 'Selecteer gebruikerstype...',
      },
      pagination: {
        loadMore: 'Meer Laden',
        loading: 'Laden...',
        showing: '{{current}} van {{total}} gebruikers weergegeven',
        showingUnverified:
          '{{current}} niet-geverifieerde gebruikers weergegeven',
        showingVerified: '{{current}} geverifieerde gebruikers weergegeven',
      },
      title: 'Gebruikers',
      unknown: 'onbekend',
    },
  },
  widgets: {
    externalCareProviders: {
      ['orthopedic-physiotherapist']: {
        description:
          'Xpert Clinics werkt samen met fysiotherapeuten die goed weten hoe ze u het beste kunnen helpen.',
        listView: 'Lijst',
        mapView: 'Kaart',
        noResults: 'Geen fysiotherapeuten gevonden',
        noResultsCaption:
          'Vul de volledige postcode in (bijv. 1234 BA) om een locatie in de buurt te vinden',
        searchPlaceholder: 'Zoek fysiotherapeuten of postcode',
        title: 'Ontdek onze fysiotherapeuten',
      },
    },
  },
}
